// File: src/components/layouts/Core/Stack/Stack.tsx
// Purpose: Layout or container component

import React from "react";
import styled from "styled-components";
import { AppTheme } from "theme";

export interface StackProps {
  children: React.ReactNode;
  direction?: "vertical" | "horizontal"; // Stack direction
  gap?:  keyof AppTheme["spacing"]; // Uses theme spacing
  align?: "start" | "center" | "end" | "stretch"; // Align items
  justify?: "start" | "center" | "end" | "space-between" | "space-around"; // Justify items
  fullWidth?: boolean; // Makes stack take full width
  responsive?: boolean; // Enables responsive stacking
}

const StyledStack = styled.div<StackProps>`
  display: flex;
  flex-direction: ${({ direction }) => (direction === "horizontal" ? "row" : "column")};
  gap: ${({ theme, gap }) => (gap ? theme.spacing[gap] : theme.spacing.md)};
  align-items: ${({ align }) => align || "stretch"};
  justify-content: ${({ justify }) => justify || "start"};
  ${({ fullWidth }) => fullWidth && "width: 100%;"}

  ${({ responsive, theme }) =>
    responsive &&
    `
    @media (max-width: ${theme.breakpoints.mobile}) {
      flex-direction: column;
      gap: ${theme.spacing.sm};
    }
  `}
`;

export const Stack: React.FC<StackProps> = ({
  children,
  direction = "vertical",
  gap = "md",
  fullWidth = false,
  responsive = true,
  ...props
}) => {
  return (
    <StyledStack direction={direction} gap={gap} fullWidth={fullWidth} responsive={responsive} {...props}>
      {children}
    </StyledStack>
  );
};